/* Patagonia Café — édition expresse du panier Shopify, sans changer de page. */
(function(){
  'use strict';
  function init(){
    var banner=document.querySelector('[data-pc-cart-reminder]');
    var host=banner&&banner.querySelector('[data-pc-cart-items]');
    var editor=banner&&banner.querySelector('[data-pc-cart-editor]');
    if(!host||!editor||editor.dataset.ready==='1')return;
    editor.dataset.ready='1';
    var title=editor.querySelector('[data-pc-editor-name]');
    var status=editor.querySelector('[data-pc-editor-status]');
    var formatArea=editor.querySelector('[data-pc-editor-formats]');
    var formatButtons=Array.from(editor.querySelectorAll('[data-pc-editor-format]'));
    var prepLabel=editor.querySelector('[data-pc-editor-preparation]');
    var grindArea=editor.querySelector('[data-pc-editor-grind]');
    var grindButtons=Array.from(editor.querySelectorAll('[data-pc-editor-grind-choice]'));
    var quantityLabel=editor.querySelector('[data-pc-editor-quantity]');
    var minus=editor.querySelector('[data-pc-editor-qty="-1"]');
    var plus=editor.querySelector('[data-pc-editor-qty="1"]');
    var remove=editor.querySelector('[data-pc-editor-remove]');
    var closer=editor.querySelector('[data-pc-editor-close]');
    var productCache=new Map();
    var supported=new Set([
      'sol-andino-sierra-alta','signature-tierra-suave','patagonia-ouro-preto',
      'espresso-brasa-morena','brasil-minas-gerais','colombia-tolima','honduras-la-paz'
    ]);
    var activeKey=null,activeButton=null,activeItem=null,currentProduct=null;
    var loading=false,openVersion=0;
    function root(){
      var p=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root;
      return p&&typeof p==='string'?(p.endsWith('/')?p:p+'/'):'/';
    }
    function euro(value){
      return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format((Number(value)||0)/100);
    }
    function sizeOf(title){
      var match=String(title||'').match(/(?:^|[^0-9])(500\s*g|1\s*kg)(?=$|[^a-z0-9])/i);
      return match?/^1\s*kg/i.test(match[1])?'1 kg':'500 g':null;
    }
    function preparationOf(line){
      return /moulu/i.test(String(line.variant_title||''))?'Moulu':/grain/i.test(String(line.variant_title||''))?'Grain':null;
    }
    function preparedValue(line){
      var p=line&&line.properties&&line.properties.Mouture;
      return typeof p==='string'&&p.trim()?p.trim():null;
    }
    function setStatus(text){
      status.hidden=!text;
      status.textContent=text||'';
    }
    function setBusy(value){
      loading=!!value;
      editor.dataset.busy=loading?'true':'false';
      editor.querySelectorAll('button').forEach(function(button){
        if(button===closer){button.disabled=loading;return}
        button.disabled=loading||button.dataset.disabledByStock==='1';
      });
      if(!loading){
        minus.disabled=!activeItem||Number(activeItem.quantity)<=1;
        plus.disabled=!activeItem||Number(activeItem.quantity)>=50;
      }
    }
    function closeEditor(){
      if(loading)return;
      editor.hidden=true;
      if(activeButton&&activeButton.isConnected){
        activeButton.setAttribute('aria-expanded','false');
      }
      activeKey=null;activeButton=null;activeItem=null;currentProduct=null;
      openVersion++;
      setStatus('');
    }
    function position(button){
      if(window.matchMedia('(max-width:749px)').matches){
        editor.style.left='50%';
        return;
      }
      var bounds=banner.getBoundingClientRect(),anchor=button.getBoundingClientRect();
      var width=editor.getBoundingClientRect().width||342;
      var left=anchor.left-bounds.left+(anchor.width-width)/2;
      editor.style.left=Math.round(Math.max(8,Math.min(bounds.width-width-8,left)))+'px';
    }
    async function readJSON(path){
      var response=await fetch(root()+path,{
        method:'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}
      });
      var body=await response.json().catch(function(){return null});
      if(!response.ok||!body)throw new Error('Impossible de lire le panier. Réessayez.');
      return body;
    }
    async function post(path,data){
      var response=await fetch(root()+path,{
        method:'POST',credentials:'same-origin',headers:{
          'Content-Type':'application/json',Accept:'application/json'
        },body:JSON.stringify(data)
      });
      var body=await response.json().catch(function(){return {}});
      if(!response.ok||body.status>=400){
        throw new Error(body.description||body.message||'Modification indisponible. Réessayez.');
      }
      return body;
    }
    function productByHandle(handle){
      if(productCache.has(handle))return productCache.get(handle);
      var pending=readJSON('products/'+encodeURIComponent(handle)+'.js')
        .then(function(product){
          if(!product||!Array.isArray(product.variants))throw new Error('Formats indisponibles.');
          return product;
        }).catch(function(error){
          productCache.delete(handle);
          throw error;
        });
      productCache.set(handle,pending);
      return pending;
    }
    function formatVariant(product,size,prep){
      if(!product||!prep)return null;
      return product.variants.find(function(variant){
        return sizeOf(variant.title)===size&&preparationOf({variant_title:variant.title})===prep;
      })||null;
    }
    function propertyCopy(line){
      var p=line&&line.properties;
      if(!p||typeof p!=='object'||Array.isArray(p))return {};
      var copy={};
      Object.keys(p).forEach(function(k){if(p[k]!==null&&p[k]!==undefined)copy[k]=p[k]});
      return copy;
    }
    function sameProperties(a,b){
      var left=propertyCopy({properties:a}),right=propertyCopy({properties:b});
      var ak=Object.keys(left).sort(),bk=Object.keys(right).sort();
      return ak.length===bk.length&&ak.every(function(k,i){
        return k===bk[i]&&String(left[k])===String(right[k]);
      });
    }
    function renderFormats(){
      var size=sizeOf(activeItem&&activeItem.variant_title);
      var prep=preparationOf(activeItem||{});
      var grind=preparedValue(activeItem);
      var isCoffee=!!activeItem&&supported.has(activeItem.handle)&&!activeItem.selling_plan_allocation;
      formatArea.hidden=!isCoffee;
      if(!isCoffee)return;
      prepLabel.textContent=prep==='Moulu'
        ? 'Café moulu · '+(grind?'Mouture actuelle : '+grind:'Choisissez Espresso ou Café filtre')
        : 'Café en grains · aucune mouture à choisir';
      grindArea.hidden=prep!=='Moulu';
      grindButtons.forEach(function(button){
        var choice=button.dataset.pcEditorGrindChoice;
        var active=prep==='Moulu'&&choice===grind;
        button.classList.toggle('is-current',active);
        button.setAttribute('aria-pressed',active?'true':'false');
        button.dataset.disabledByStock=prep==='Moulu'?'0':'1';
        button.disabled=loading||prep!=='Moulu';
      });
      formatButtons.forEach(function(button){
        var desired=button.dataset.pcEditorFormat;
        var variant=currentProduct&&formatVariant(currentProduct,desired,prep);
        var active=desired===size;
        var allowed=!!variant&&variant.available!==false&&(prep!=='Moulu'||!!grind);
        button.classList.toggle('is-current',active);
        button.setAttribute('aria-pressed',active?'true':'false');
        button.dataset.disabledByStock=allowed?'0':'1';
        button.disabled=loading||!allowed;
        var price=button.querySelector('[data-pc-editor-format-price]');
        price.textContent=variant?euro(variant.price):currentProduct?'Indisponible':'Vérification…';
      });
    }
    async function openEditor(button){
      var key=button.dataset.pcCartEditKey;
      if(!key||loading)return;
      if(activeKey===key&&!editor.hidden){closeEditor();return}
      if(activeButton&&activeButton.isConnected)activeButton.setAttribute('aria-expanded','false');
      activeKey=key;activeButton=button;activeItem=null;currentProduct=null;
      var token=++openVersion;
      button.setAttribute('aria-expanded','true');
      editor.hidden=false;
      title.textContent='Votre café Patagonia';
      quantityLabel.textContent='–';
      formatArea.hidden=true;
      grindArea.hidden=true;
      setBusy(true);
      setStatus('Vérification du panier…');
      position(button);
      try{
        var cart=await readJSON('cart.js');
        if(token!==openVersion)return;
        var line=cart.items.find(function(item){return String(item.key)===String(key)});
        if(!line)throw new Error('Ce produit a déjà changé. Rouvrez son encart.');
        activeItem=line;
        title.textContent=line.product_title||line.title||'Café Patagonia';
        quantityLabel.textContent=String(line.quantity);
        var supportedCoffee=supported.has(line.handle)&&!line.selling_plan_allocation;
        if(supportedCoffee){
          formatArea.hidden=false;
          renderFormats();
          try{
            var product=await productByHandle(line.handle);
            if(token!==openVersion)return;
            currentProduct=product;
            renderFormats();
            if(preparationOf(line)==='Moulu'&&!preparedValue(line)){
              setStatus('Ce café moulu doit d’abord avoir une préparation Espresso ou Filtre définie.');
            }else{
              setStatus('');
            }
          }catch(error){
            currentProduct=null;
            renderFormats();
            setStatus('Les formats sont momentanément indisponibles. Vous pouvez changer la quantité ou retirer le café.');
          }
        }else{
          setStatus('Le format de cette formule se gère dans le panier. La quantité reste modifiable ici.');
        }
      }catch(error){
        if(token!==openVersion)return;
        setStatus(error.message);
      }finally{
        if(token===openVersion)setBusy(false);
      }
      position(button);
    }
    function emitCart(cart){
      if(!cart||!Array.isArray(cart.items))return;
      document.dispatchEvent(new CustomEvent('pcf:cart-updated',{detail:cart}));
      var offer=window.PatagoniaOffer;
      if(offer&&typeof offer.refreshCart==='function'){
        Promise.resolve(offer.refreshCart()).catch(function(){});
      }else if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){
        publish(PUB_SUB_EVENTS.cartUpdate,{source:'pc-cart-reminder'});
      }
    }
    async function execute(action,argument){
      if(loading||!activeKey)return;
      var before=activeKey,token=++openVersion;
      setBusy(true);
      setStatus('Mise à jour de votre panier…');
      try{
        var cart=await readJSON('cart.js');
        var line=cart.items.find(function(item){return String(item.key)===String(before)});
        if(!line)throw new Error('Ce café a déjà été modifié. Rouvrez-le dans le bandeau.');
        var result;
        if(action==='quantity'||action==='remove'){
          var newQty=action==='remove'?0:Math.max(1,Math.min(50,Number(line.quantity)+Number(argument)));
          if(newQty===Number(line.quantity))return;
          result=await post('cart/change.js',{id:line.key,quantity:newQty});
        }else if(action==='grind'){
          if(!supported.has(line.handle)||line.selling_plan_allocation||preparationOf(line)!=='Moulu'){
            throw new Error('Cette référence ne permet pas le changement de mouture.');
          }
          var choice=String(argument);
          if(choice!=='Espresso'&&choice!=='Filtre'){
            throw new Error('Choisissez Espresso ou Café filtre.');
          }
          if(preparedValue(line)===choice){setStatus('');return}
          var updatedProps=propertyCopy(line);
          updatedProps.Mouture=choice;
          result=await post('cart/change.js',{
            id:line.key,quantity:Number(line.quantity),properties:updatedProps
          });
        }else if(action==='format'){
          if(!supported.has(line.handle)||line.selling_plan_allocation)throw new Error('Cette formule ne permet pas ce changement rapide.');
          var prep=preparationOf(line);
          if(!prep)throw new Error('Préparation du café non reconnue.');
          var grind=preparedValue(line);
          if(prep==='Moulu'&&!grind)throw new Error('Précisez la mouture Espresso ou Filtre sur la fiche de ce café.');
          var product=await productByHandle(line.handle);
          var target=formatVariant(product,argument,prep);
          if(!target||target.available===false)throw new Error('Ce format n’est pas disponible actuellement.');
          if(String(target.id)===String(line.variant_id||line.id))return;
          var properties=propertyCopy(line);
          var addition={id:Number(target.id),quantity:Number(line.quantity),properties:properties};
          var other=cart.items.find(function(i){
            return String(i.variant_id||i.id)===String(target.id)&&!i.selling_plan_allocation&&sameProperties(i.properties,properties);
          });
          var added=await post('cart/add.js',{items:[addition]});
          try{
            result=await post('cart/change.js',{id:line.key,quantity:0});
          }catch(removeError){
            // Restaurer la quantité de la variante de destination en cas d'échec de retrait.
            try{
              var addedLine=added&&Array.isArray(added.items)?added.items[0]:added;
              var addedKey=addedLine&&addedLine.key;
              if(addedKey)await post('cart/change.js',{id:addedKey,quantity:other?Number(other.quantity):0});
            }catch(rollbackError){}
            throw new Error('Modification incomplète. Vérifiez votre panier avant de continuer.');
          }
        }else return;
        if(token!==openVersion)return;
        emitCart(result);
        loading=false;
        closeEditor();
      }catch(error){
        if(token!==openVersion)return;
        try{
          var actual=await readJSON('cart.js');
          emitCart(actual);
          activeItem=actual.items.find(function(i){return String(i.key)===String(before)})||activeItem;
        }catch(ignore){}
        setStatus(error&&error.message?error.message:'Mise à jour impossible. Réessayez.');
      }finally{
        if(token===openVersion)setBusy(false);
      }
    }
    host.addEventListener('click',function(event){
      var button=event.target&&event.target.closest?event.target.closest('[data-pc-cart-edit-key]'):null;
      if(button&&host.contains(button)){
        event.preventDefault();
        openEditor(button);
      }
    });
    formatButtons.forEach(function(button){
      button.addEventListener('click',function(){execute('format',button.dataset.pcEditorFormat)});
    });
    grindButtons.forEach(function(button){
      button.addEventListener('click',function(){execute('grind',button.dataset.pcEditorGrindChoice)});
    });
    editor.querySelectorAll('[data-pc-editor-qty]').forEach(function(button){
      button.addEventListener('click',function(){execute('quantity',Number(button.dataset.pcEditorQty))});
    });
    remove.addEventListener('click',function(){execute('remove',0)});
    closer.addEventListener('click',closeEditor);
    document.addEventListener('pointerdown',function(event){
      if(editor.hidden||loading)return;
      if(editor.contains(event.target)||host.contains(event.target))return;
      closeEditor();
    },true);
    document.addEventListener('keydown',function(event){
      if(event.key==='Escape'&&!editor.hidden&&!loading){closeEditor()}
    });
    window.addEventListener('resize',function(){
      if(!editor.hidden&&activeButton)position(activeButton);
    });
    // Si un autre composant modifie le panier, ne plus éditer une ancienne ligne.
    document.addEventListener('pcf:cart-updated',function(event){
      if(editor.hidden||loading||!event.detail||!Array.isArray(event.detail.items))return;
      if(!event.detail.items.some(function(item){return String(item.key)===String(activeKey)}))closeEditor();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
